export default __webpack_public_path__ + "assets/models/a5f9dea100a4d2eb507f6d398ad2e929.gltf";